module.exports = __webpack_public_path__ + "static/img/home-banner.d9218952.jpg";